<div class="container-fluid h-100">
  <div class="row h-100 ">
    <div class="col-auto bg-white h-100 d-none d-lg-block">
      <Sidebar ref="sidebar"></Sidebar>
    </div>
    <div class="col bg-white h-100 m-0">
      <Navbar @toggle-sidebar="toggleSidebar"></Navbar>
      <div class="bg-gray px-4 py-1 h-100">
        <div class="card bg-white rounded-5 mt-2 shadow border-0">
          <div class="card-header bg-transparent border-0">
            <span class="fw-500">Membership History </span>
          </div>
          <div class="card-body table-responsive">
            <table class="table table-striped text-xxs mt-3">
              <thead class="bg-dark text-white">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Membership Name</th>
                  <th scope="col">Membership Type</th>
                  <th scope="col">Membership Amount</th>
                  <th scope="col">User Full Name</th>
                  <th scope="col">Membership Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(membership_history, index) in membership_payment_history" :key="membership_history.id">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{membership_name}}</td>
                    <td>{{membership_type }}</td>
                    <td>{{ membership_price }}</td>
                    <td>{{ user_first_name }} {{ user_last_name }}</td>
                    <td>{{ payment_status }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
   
</div>